<!-- Floating Button -->
<button *ngIf="!isOpen"
        (click)="openChat()"
        class="fixed bottom-6 right-6 h-14 w-14 rounded-full
               bg-[#006600] text-white shadow-lg text-xl z-50">
  💬
</button>

<!-- Chatbot Container -->
<div [class.hidden]="!isOpen"
     class="fixed bottom-6 right-6 bg-white shadow-2xl
            rounded-2xl border border-gray-200 z-50 flex flex-col
            transition-all duration-300"
     [ngClass]="isMinimized ? 'w-72 h-36' : 'w-[600px] h-[600px]'">

  <!-- Header -->
  <div class="flex items-center justify-between px-4 py-2
              bg-[#0AAE94] text-white rounded-t-2xl">
    <span class="font-semibold">AI Helpdesk</span>

    <div class="flex gap-2">
      <button *ngIf="!isMinimized" (click)="minimizeChat()">➖</button>
      <button *ngIf="isMinimized" (click)="expandChat()">🔼</button>
      <button (click)="closeChat()">✖</button>
    </div>
  </div>

  <!-- IFRAME (never destroyed) -->
  <div class="flex-1 relative overflow-hidden bg-white">
    <iframe
      [src]="safeChatbotUrl"
      class="w-full h-full border-0"
      sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
      loading="eager"
      referrerpolicy="no-referrer">
    </iframe>
  </div>

</div>
